import { SAVE_USER_ID } from './types'

export const saveUserId = (uid) => {
  //   alert(`${uid}`)
  return {
    type: SAVE_USER_ID,
    payload: uid,
  }
}
